import type { InputProps } from "@mui/material";
import { Input } from "@mui/material";
import classNames from "classnames";
import type { FC } from "react";
import type { TypeTextType } from "./AppInputStatus";
import { AppInputStatus } from "./AppInputStatus";
import styles from "./styles.module.css";

type Props = InputProps & {
  className?: string;
  inputClassName?: string;
  status?: TypeTextType;
  small?: boolean;
};

export const AppInput: FC<Props> = ({
  className,
  inputClassName,
  status,
  small,
  disabled,
  ...props
}) => {
  return (
    <Input
      fullWidth
      disableUnderline
      endAdornment={status && <AppInputStatus type={status} />}
      classes={{
        input: classNames(
          styles.input,
          {
            [styles.small]: small,
          },
          inputClassName
        ),
      }}
      className={classNames(
        styles.container,
        { [styles.disabled]: disabled },
        className
      )}
      disabled={disabled}
      {...props}
    />
  );
};
